import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import FetchAndRedirect from "./FetchAndRedirect";
import TargetPage from "./TargetPage";
import ReturnPage from "./Return";
import TelegramRedirect from "./TelegramRedirect";
import AppErrorBoundary from "./components/ErrorBounery";
export default function App() {
  return (
    <AppErrorBoundary>
      <Router>
        <Routes>
          <Route path="/refer" element={<FetchAndRedirect />} />
          {/* <Route path="/qrcode" element={<QrPayment />} /> */}
          {/* <Route path="/target" element={<TargetPage />} /> */}
          <Route path="/return" element={<ReturnPage />} />
          {/* <Route path="/telegram" element={<TelegramRedirect />} /> */}
        </Routes>
      </Router>
    </AppErrorBoundary>
  );
}
